import { render, staticRenderFns } from "./roleMenuForm.vue?vue&type=template&id=06d777a0&"
import script from "./roleMenuForm.vue?vue&type=script&lang=js&"
export * from "./roleMenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports